import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-444c386c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-notes" }
const _hoisted_2 = { class: "accounting-details" }
const _hoisted_3 = { class: "table-top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__left" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Notes"),
  /*#__PURE__*/_createElementVNode("h2", null, "Risk and investigation notes")
], -1))
const _hoisted_5 = { class: "__middle" }
const _hoisted_6 = { class: "checkbox-button" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Show risk notes only")
], -1))
const _hoisted_8 = { class: "__right" }
const _hoisted_9 = { class: "ls-table" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["colspan"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { key: 2 }
const _hoisted_15 = ["colspan"]
const _hoisted_16 = { "data-label": "Date" }
const _hoisted_17 = { "data-label": "Notes" }
const _hoisted_18 = {
  key: 0,
  class: "note-start"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "note-start" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = {
  key: 2,
  class: "name"
}

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_AddEditModal = _resolveComponent("AddEditModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.showRiskNote) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.showRiskNote]
            ]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.showAddEditModal = true))
          }, "Add risk notes")
        ])
      ]),
      _createElementVNode("table", _hoisted_9, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notesHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("p", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                _createElementVNode("td", {
                  colspan: _ctx.notesHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_11)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                  _createElementVNode("td", {
                    colspan: _ctx.notesHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_13)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.notes.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _createElementVNode("td", {
                      colspan: _ctx.notesHeadings.length
                    }, "No Records", 8, _hoisted_15)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.notes.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.notes, (n) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$formatDate(n.createdOn)), 1),
                        _createElementVNode("td", _hoisted_17, [
                          (n.notesType.id == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(n.practiceNote.practiceRisk.name) + " | " + _toDisplayString(n.practiceNote.practiceRiskIndicator.name), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("span", _hoisted_20, [
                                  _createElementVNode("i", null, [
                                    _createElementVNode("b", {
                                      class: "link",
                                      onClick: $event => (_ctx.showInvestigationDetails(n.investigationNote.investigation))
                                    }, _toDisplayString(n.investigationNote?.investigationType?.description), 9, _hoisted_21),
                                    _createTextVNode(", - " + _toDisplayString(n.trustTeamMember?.displayName) + " " + _toDisplayString(_ctx.$formatDateTimeTypeA(n.createdOn)), 1)
                                  ])
                                ])
                              ])),
                          _createTextVNode(" " + _toDisplayString(n.content) + " ", 1),
                          _hoisted_22,
                          (n.notesType.id == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(n.trustTeamMemberName), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showAddEditModal)
      ? (_openBlock(), _createBlock(_component_AddEditModal, {
          key: 0,
          onCloseModal: _cache[2] || (_cache[2] = $event => (_ctx.showAddEditModal = false))
        }))
      : _createCommentVNode("", true)
  ]))
}